import { createStore } from '~/store/createStore';
export const usePageWinner98Store = createStore(() => {
    return { strategyType: 1 };
});
